import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Documento from "model/documentos/Documento";
import DocumentoAssociacao from "model/documentos/DocumentoAssociacao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DocumentoService from "service/documentos/DocumentoService";

interface ModalDocumentoRelacionadoProps {
    visible: boolean;
    onHide: () => void;
    documento: Documento | null;
}

const documentoService = new DocumentoService();

export default function ModalDocumentoRelacionado(props: ModalDocumentoRelacionadoProps) {

    const [documentos, setDocumentos] = useState<Documento[]>([]);
    const [documentoRelacionado, setDocumentoRelacionado] = useState<DocumentoAssociacao>(new DocumentoAssociacao());
    const { msgErro, msgSucesso } = useToastContext();
    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        documentoService.documentos().then((response) => {
            setDocumentos(response);
        }).catch((error) => {
            console.error("Erro ao buscar documentos:", error);
            msgErro("Erro", "Erro ao buscar documentos: " + error.message)
        });

        setDocumentoRelacionado({ ...documentoRelacionado, documento: props.documento });
    }, [])

    function salvarDocumentoRelacionado() {
        startLoading();
        documentoService.incluirDocumentoRelacionado(documentoRelacionado).then(resposta => {
            props.onHide();
            msgSucesso('Documento relacionado', 'Registro gravado com sucesso');
            stopLoading();
        }).catch(error => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro('Documento relacionado', error.data.message);
            } else {
                msgErro('Documento relacionado', 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
            stopLoading();
        });
    }

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        <Button label="Gravar" icon="pi pi-check" className="p-button-text" onClick={() => salvarDocumentoRelacionado()} />
    </div>

    return (
        <>
            <Dialog visible={props.visible} baseZIndex={100} style={{ width: '65vw', minHeight: "50vh" }} modal onHide={props.onHide}
                header="Adicionar Documento" footer={footer}>

                <div className="row">
                    <Label className="col col-sm-12" obrigatorio>Documento</Label>
                    <div className="col-sm-12">
                        <Controller name="documentos" control={control} render={({ field }) => (
                            <Dropdown
                                focusInputRef={field.ref}
                                options={documentos}
                                className={errors.documentos ? "p-invalid" : ""}
                                optionLabel='nome'
                                value={documentoRelacionado.documentoAssociado}
                                onChange={(e) => {
                                    setDocumentoRelacionado({ ...documentoRelacionado, documentoAssociado: e.value })
                                    clearErrors("documentos")
                                }}
                                style={{ width: '100%' }}
                            />
                        )} />
                    </div>
                    {errors.documentos && errors.documentos.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.documentos?.message as string}</span> : null}
                </div>

            </Dialog>
        </>
    )
}